import { TelegramChart, TelegramChartZoom, TelegramChartDataSelector, TelegramChartTooltipFeature, TelegramChartLabelsFeature, ZoomConfig } from '@telegram/charts';

(window as any).loadAndRenderCharts = function () {
  const charts: Array<TelegramChart> = [];

  const titles = ['Followers', 'Interactions', 'Messages', 'Growth', 'Apps'];
  const labelColors = ['#8E8E93', '8E8E93', '#25252980', '8E8E93', '#25252980'];
  const chartHeight = 340;//window.innerHeight * 0.6;

  for (let i = 0; i < 5; i++) {
    //if(i != 2) {continue;}
    const chartContainer = document.getElementById(`chartContainer${i}`);
    chartContainer.style.height = chartHeight + 'px';
    const chart = new TelegramChart(document, chartContainer, titles[i]);
    const chartZoom = new TelegramChartZoom(chart, document.getElementById(`chartZoomContainer${i}`));
    const chartDataSelector = new TelegramChartDataSelector(chart, document.getElementById(`chartDataSelectorContainer${i}`));
    const chartTooltip = new TelegramChartTooltipFeature();
    chart.mainRenderTarget.addFeature(chartTooltip);
    const chartLabels = new TelegramChartLabelsFeature();

    chart.mainRenderTarget.addFeature(chartLabels);

    if (i < 2) {
      chart.mainRenderTarget.autoAdjustYMin = true;
    } else {
      chart.mainRenderTarget.autoAdjustYMin = false;
    }

    const zoomLevelsConfig: Array<ZoomConfig> = [
      {
        xStep: TelegramChart.oneDayMilliseconds,
        dataUrlFunction: (xValue) => {
          return `contest/${i + 1}/overview.json`;
        }
      }
    ];

    if(i < 4) {
      zoomLevelsConfig.push({
        xStep: TelegramChart.oneHourMilliseconds,
        dataUrlFunction: (xValue) => {
          const dateObj = new Date(xValue);

          let month = dateObj.getMonth() + 1;
          let date = dateObj.getDate();

          let m = month.toString().length == 1 ? `0${month}` : month;
          let d = date.toString().length == 1 ? `0${date}` : date;

          return `contest/${i + 1}/${dateObj.getFullYear()}-${m}/${d}.json`;
        }
      });
    }

    chart.zoomLevelsConfig = zoomLevelsConfig;
    chart.zoomIn(0);

    charts.push(chart);
  }

  const colorSwitchButton = document.getElementById('color-mode-switch');

  const chartColorSchemes = {
  };

  chartColorSchemes['light'] = {
    labelColor: '#96a2aa',
    lineColor: '#e7e9eb',
    tooltipLineColor: '#dfe6eb',
    backgroundColor: '#ffffff'
  };
  chartColorSchemes['dark'] = {
    labelColor: '#546778',
    lineColor: '#313d4d',
    tooltipLineColor: '#3b4a5a',
    backgroundColor: '#242f3e'
  };

  colorSwitchButton.onclick = function () {
    const mode = document.body.className.indexOf('dark') > -1 ? 'light' : 'dark';
    document.body.className = mode;

    const colorScheme = chartColorSchemes[mode];

    for (let i = 0; i < charts.length; i++) {
      //charts[i].labelColor = colorScheme.labelColor;
      charts[i].lineColor = colorScheme.lineColor;
      charts[i].tooltipLineColor = colorScheme.tooltipLineColor;
      charts[i].backgroundColor = colorScheme.backgroundColor;
      charts[i].mainRenderTarget.viewportChanged = true;
      charts[i].requestRender();
    }

    colorSwitchButton.innerHTML = mode == 'light' ? 'Switch to Night Mode' : 'Switch to Day Mode';
  }
}